import { Component, Input } from '@angular/core';

@Component({
  selector: 'rmt-hint',
  templateUrl: 'rmt-hint.html'
})
export class RmtHintComponent {
  @Input() hint;
  @Input() error;
  @Input() content;
  @Input() hintId:string='';
  @Input() showHint: boolean = true;
  @Input() showError: boolean = true;
  

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-hint/rmt-hint.ts